import React, { useState, useEffect } from 'react'
import { FormContentsModel } from '../models/StoreDetailModel'
import { Image, Text, View } from 'react-native'
import { TouchableOpacity } from 'react-native-gesture-handler'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { DotsNavigation } from '../../navigation/stacks/NavigationStack'
import styles from './ImageFormItemStyles'
import useImageLoader from '../../../hooks/useImageLoader'
import { PATH_ASSETS } from '../../../utils/Constants'
import { Loader } from '../../customUtils/Components/Loader'

export const ImageFormItem = ({ item }: { item: FormContentsModel }) => {
    const navigation = useNavigation<StackNavigationProp<DotsNavigation>>()

    const { image, loading } = useImageLoader(item.media, PATH_ASSETS)


    const goToLink = (data: string) => {
        if (!data) return
        const params = {
            link: data,
        }
        navigation.navigate('WebView', params as undefined)
    }

    const [imageAspectRatio, setImageAspectRatio] = useState(1)

    useEffect(() => {
        if (item.media) {
            Image.getSize(
                item.media,
                (width, height) => {
                    setImageAspectRatio(width / height)
                },
                (error) => {
                    console.error('Error al obtener el tamaño de la imagen: ', error)
                },
            )
        }
    }, [item.media])

    return (
        <View>
            {image && (
                <View>
                    {
                        loading
                        ? <Loader />
                        : <Image source={{ uri: image }} style={[styles.image, { aspectRatio: imageAspectRatio }]} />
                    }
                </View>
            )}

            <View style={styles.buttonContainer}>
                <TouchableOpacity onPress={() => goToLink(item.description)} style={styles.mainButtonActive}>
                    <Text style={styles.mainButtonTextActive}>Ir a formulario</Text>
                </TouchableOpacity>
            </View>
        </View>
    )
}
